import React, { useContext } from "react"
import { UIContext } from "../../../components/shared/layout"
import {
  LightboxContentWrapper,
  LightboxControls,
  LightboxWrapper,
} from "./lightbox.styles"

const SliderLightbox = ({ children, toggle, index = 0 }) => {
  const {
    state: { clientLoaded },
  } = useContext(UIContext)

  return (
    <LightboxWrapper>
      <LightboxControls>
        <button onClick={toggle}>Close</button>
      </LightboxControls>
      {clientLoaded && (
        <LightboxContentWrapper onClick={toggle}>
          <div
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {children}
          </div>
        </LightboxContentWrapper>
      )}
    </LightboxWrapper>
  )
}

export default SliderLightbox
